import { TableData } from '@anytag/shared-types';
import { TiktokUserTagListPostsItemPayload } from '@anytag/graphql';
import { TiktokTagPostDetailsModal } from '@anytag/shared-molecules';
import { TagsTable } from '../../shared';
import { ProfilePostsCount } from '../../../ProfilePostsList';
import { useTiktokTagsAnalyticsPostsListTable } from './hooks';

export type TiktokTagsAnalyticsPostsListProps = TableData<TiktokUserTagListPostsItemPayload>;

export const TiktokTagsAnalyticsPostsList = ({
  loading,
  data = [],
  totalRecords
}: TiktokTagsAnalyticsPostsListProps) => {
  const { columns } = useTiktokTagsAnalyticsPostsListTable({ data });

  return (
    <>
      <ProfilePostsCount count={totalRecords} className="shadow-none" />
      <TagsTable loading={loading} hasBorder={!!totalRecords} data={data} columns={columns} />
      <TiktokTagPostDetailsModal posts={data.map(({ postId }) => ({ id: postId }))} />
    </>
  );
};
